import { render, staticRenderFns } from "./questionSubjective.vue?vue&type=template&id=5a944ca8&scoped=true"
import script from "./questionSubjective.vue?vue&type=script&lang=js"
export * from "./questionSubjective.vue?vue&type=script&lang=js"
import style0 from "./questionSubjective.vue?vue&type=style&index=0&id=5a944ca8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a944ca8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\project\\fashang\\cqykdx\\student_pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a944ca8')) {
      api.createRecord('5a944ca8', component.options)
    } else {
      api.reload('5a944ca8', component.options)
    }
    module.hot.accept("./questionSubjective.vue?vue&type=template&id=5a944ca8&scoped=true", function () {
      api.rerender('5a944ca8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/questionType/questionSubjective.vue"
export default component.exports